// Important to import CSS above everything else to keep correct order
import navBarClasses from "./assets/styles/appShell.module.css";

import React from "react";
import { AppShell, Box } from "@mantine/core";
import { Route, Routes } from "react-router-dom";
import LeftNavbarLink from "./components/LeftNavbarLink";
import DashboardIcon from "./assets/icons/DashboardIcon";
import Overview from "./routes/Overview";
import Login from "./routes/Login";
import ResponseTimes from "./routes/ResponseTimes";
import PartNetworking from "./routes/PartNetworking";
import PrivateRoute from "./components/PrivateRoute";
import SingleNodeResponseTimes from "./routes/SingleNodeResponseTimes";

const App: React.FC = () => {
  const appS = (
    <AppShell
      // Providing the width here allows mantine to give the correct spacing to the body
      navbar={{ width: 175, breakpoint: "xs" }}
      classNames={{ navbar: navBarClasses.navBar, main: navBarClasses.main }}
    >
      <AppShell.Navbar p="xs">
        <LeftNavbarLink
          title="Overview"
          href="/overview"
          icon={<DashboardIcon />}
          activeRoutes={["/", "/overview"]}
          key="overview"
        />
        <LeftNavbarLink
          title="Response Times"
          href="/responseTimes"
          icon={<DashboardIcon />}
          activeRoutes={["/responseTimes"]}
          key="responseTimes"
        />
        <LeftNavbarLink
          title="Historical Response Times"
          href="/singleNodeResponseTimes"
          icon={<DashboardIcon />}
          activeRoutes={["/singleNodeResponseTimes"]}
          key="singleNodeResponseTimes"
        />
        <LeftNavbarLink
          title="Part Networking"
          href="/partNetworking"
          icon={<DashboardIcon />}
          activeRoutes={["/partNetworking"]}
          key="partNetworking"
        />
      </AppShell.Navbar>
      <AppShell.Main>
        <Box ml={60} mr={60} mt={24}>
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Overview />
                </PrivateRoute>
              }
            />
            <Route
              path="/overview"
              element={
                <PrivateRoute>
                  <Overview />
                </PrivateRoute>
              }
            />
            <Route path="/login" element={<Login />} />

            <Route
              path="/responseTimes"
              element={
                <PrivateRoute>
                  <ResponseTimes />
                </PrivateRoute>
              }
            />
            <Route
              path="/singleNodeResponseTimes"
              element={
                <PrivateRoute>
                  <SingleNodeResponseTimes />
                </PrivateRoute>
              }
            />
            <Route
              path="/partNetworking"
              element={
                <PrivateRoute>
                  <PartNetworking />
                </PrivateRoute>
              }
            />
          </Routes>
        </Box>
      </AppShell.Main>
    </AppShell>
  );

  return appS;
};

export default App;
